import Vue from 'vue'
import ResetPassword from './ResetPassword.vue'
import i18n from './i18n';
import Vuelidate from 'vuelidate'

Vue.config.productionTip = false;
Vue.use(Vuelidate);

i18n.locale = window.__LANGUAGE__ ?? 'ru';

new Vue({
    i18n,
    render: h => h(ResetPassword),
}).$mount('#app')
